<template>
  <div>
    <h3>Recepción rayos X</h3>

    <v-text-field
      label="Paciente"
      v-model="paciente"
    />

    <v-btn color="success" @click="registrar">
      Registrar
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'Somatometria',
  data() {
    return {
      paciente: ''
    }
  },
  methods: {
    registrar() {
      // llamada al backend Grails
    }
  }
}
</script>
